import React from 'react';
import '../template-file-css/document-file-template.css';


export const EYPC_BiopsychosocialAssesment = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='EYPC_BiopsychosocialAssesment' className='file-pdf-document'>
            <div className='file-template'>
            <p className='w-750'>
                    <h3>A. ASSESSMENT INFORMATION (COMPLETE ALL INFORMATION)</h3>
                </p>
                <table>
                    <tr>
                        <td className='w-300'>
                            <span className='eleHeader'>Individual Name:</span>
                        </td>
                        <td className='w-300'>
                            <span className='eleHeader'>Assessor Name</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Date</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'> <input type='text' id='txtIndividualName' name='txtIndividualName' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtAssessorName' name='txtAssessorName' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDate' name='txtDate' className='add-only' /> </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-500'>
                            <span className='eleHeader'>Individual Address:</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Date of Birth:</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>Age</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtIndividualAddress' name='txtIndividualAddress' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDateOfBirth' name='txtDateOfBirth' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtAge' name='txtAge' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>City:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>State:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Zip Code:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtCity' name='txtCity' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtState' name='txtState' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtZipCode' name='txtZipCode' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-350'>
                            <span className='eleHeader'>Race/Ethnicity:</span>
                        </td>
                        <td className='w-400'>
                            <span className='eleHeader'>Sex:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'> <input type='text' id='txtRaceEthnicity' name='txtRaceEthnicity' className='add-only' /> </td>
                        <td className='w-400'>
                            <input type='radio' id='rbGender_Male' name='rbGender' className='add-only' value='Male' /> Male &nbsp;
                            <input type='radio' id='rbGender_Female' name='rbGender' className='add-only' value='Female' /> Female &nbsp;
                            <input type='radio' id='rbGender_Other' name='rbGender' className='add-only' value='Other' /> Other:&nbsp;<input type='text' id='txtGenderOtherSex' name='txtGenderOtherSex' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Sexual Orientation:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Preferred Pronouns:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Cell Phone:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtSexualOrientation' name='txtSexualOrientation' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPreferredPronouns' name='txtPreferredPronouns' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtCellPhone' name='txtCellPhone' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <span className='eleHeader'>{`Parent/Guardian (P.G) Name`}:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>P.G Phone Number:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtParentGuardianPgName' name='txtParentGuardianPgName' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPgPhoneNumber' name='txtPgPhoneNumber' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Emergency Contact (E.C) Name:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Relationship:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>E.C Phone#:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtEmergencyContactName' name='txtEmergencyContactName' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtRelationship' name='txtRelationship' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtEcPhone' name='txtEcPhone' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Are you or have you served in the military armed forces</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbServedInTheMilitaryArmedForces_Yes' name='rbServedInTheMilitaryArmedForces' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbServedInTheMilitaryArmedForces_No' name='rbServedInTheMilitaryArmedForces' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbServedInTheMilitaryArmedForces_Other' name='rbServedInTheMilitaryArmedForces' className='add-only' value='Other' /> Other:&nbsp;<input type='text' id='txtGenderOther' name='txtGenderOther' className='add-only w-375 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>INSURANCE INFORMATION</h3>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Insurance Type</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbInsuranceType_1' name='cbInsuranceType_1' className='add-only' value='Medicaid' /> Medicaid
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbInsuranceType_2' name='cbInsuranceType_2' className='add-only' value='Magellan' /> Magellan
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbInsuranceType_3' name='cbInsuranceType_3' className='add-only' value='Aetna' /> Aetna
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbInsuranceType_4' name='cbInsuranceType_4' className='add-only' value='Optima' /> Optima
                        </td>
                    </tr>
                    <tr>                        
                        <td className='w-187'>
                            <input type='checkbox' id='cbInsuranceType_5' name='cbInsuranceType_5' className='add-only' value='Molina' /> Molina
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbInsuranceType_6' name='cbInsuranceType_6' className='add-only' value='Anthem' /> Anthem
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>B. CONSUMER PRESENTATION & PRESENTING PROBLEMS</h3>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Location of Assessment:</span>
                        </td>
                        <td className='w-500'>
                            <span className='eleHeader'>Who was present during Assessment?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtLocationOfAssessment' name='txtLocationOfAssessment' className='add-only' /> </td>
                        <td className='w-500'> <input type='text' id='txtWhoWasPresentDuringAssessment' name='txtWhoWasPresentDuringAssessment' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>INTERVIEW OBSERVATIONS</h3>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Appearance</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAppearance_1' name='cbAppearance_1' className='add-only' value='WellGroomed' /> Well groomed
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAppearance_2' name='cbAppearance_2' className='add-only' value='Unkempt' /> Unkempt
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAppearance_3' name='cbAppearance_3' className='add-only' value='Disheveled' /> Disheveled
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAppearance_4' name='cbAppearance_4' className='add-only' value='Malodorous' /> Malodorous
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Build</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbBuild_1' name='cbBuild_1' className='add-only' value='Average' /> Average
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbBuild_2' name='cbBuild_2' className='add-only' value='Thin' /> Thin
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbBuild_3' name='cbBuild_3' className='add-only' value='Overweight' /> Overweight
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbBuild_4' name='cbBuild_4' className='add-only' value='Obese' /> Obese
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Demeanor</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDemeanor_1' name='cbDemeanor_1' className='add-only' value='Cooperative' /> Cooperative
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDemeanor_2' name='cbDemeanor_2' className='add-only' value='Hostile' /> Hostile
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDemeanor_3' name='cbDemeanor_3' className='add-only' value='Guarded' /> Guarded
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDemeanor_4' name='cbDemeanor_4' className='add-only' value='Withdrawn' /> Withdrawn
                        </td>
                    </tr>
                    <tr>                        
                        <td className='w-187'>
                            <input type='checkbox' id='cbDemeanor_5' name='cbDemeanor_5' className='add-only' value='Preoccupied' /> Preoccupied
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDemeanor_6' name='cbDemeanor_6' className='add-only' value='Demanding' /> Demanding
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDemeanor_7' name='cbDemeanor_7' className='add-only' value='Seductive' /> Seductive
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Eye Contact</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbEyeContact_1' name='cbEyeContact_1' className='add-only' value='Average' /> Average
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbEyeContact_2' name='cbEyeContact_2' className='add-only' value='Decreased' /> Decreased
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbEyeContact_3' name='cbEyeContact_3' className='add-only' value='Increased' /> Increased
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Speech</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSpeech_1' name='cbSpeech_1' className='add-only' value='Clear' /> Clear
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSpeech_2' name='cbSpeech_2' className='add-only' value='Slurred' /> Slurred
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSpeech_3' name='cbSpeech_3' className='add-only' value='Rapid' /> Rapid
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSpeech_4' name='cbSpeech_4' className='add-only' value='Slow' /> Slow
                        </td>
                    </tr>
                    <tr>                        
                        <td className='w-187'>
                            <input type='checkbox' id='cbSpeech_5' name='cbSpeech_5' className='add-only' value='Pressured' /> Pressured
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSpeech_6' name='cbSpeech_6' className='add-only' value='Soft' /> Soft
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSpeech_7' name='cbSpeech_7' className='add-only' value='Loud' /> Loud
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSpeech_8' name='cbSpeech_8' className='add-only' value='Monotone' /> Monotone
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Mental Status:</span>
                    <span className='small'>(Describe Consumer's mood, affect, thought processes, though contact, AVH, intelligence, insight, judgment, and orientation)</span>
                    <textarea id='txtMentalStatus' name='txtMentalStatus' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <h3>PRESENTING PROBLEM & REQUESTED SERVICE</h3>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What is the Consumer's presenting problem/why are they here? This should be in the Consumer's own words</span>
                    <textarea id='txtConsumerPresentingProblem' name='txtConsumerPresentingProblem' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Describe precipitating events</span>
                    <span className='small'>(Include the onset of the problem, duration, frequency, past intervention/services and the results of the services.)</span>
                    <textarea id='txtDescribePrecipitatingEvents' name='txtDescribePrecipitatingEvents' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Describe consumer's current level of functioning</span>
                    <textarea id='txtDescribeConsumerCurentLevel' name='txtDescribeConsumerCurentLevel' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What is the parent's/family's perception of the problem?</span>
                    <textarea id='txtWhatParentFamilyPreceptionProblem' name='txtWhatParentFamilyPreceptionProblem' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What services is the consumer asking for?</span>
                    <textarea id='txtWhatServicesConsumerAskingFor' name='txtWhatServicesConsumerAskingFor' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <h3>C. RISK & TRAUMA ASSESSMENT (INCLUDE ABUSE & NEGLECT) Check all that apply</h3>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Suicidality</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSuicidality_1' name='cbSuicidality_1' className='add-only' value='None' /> None
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSuicidality_2' name='cbSuicidality_2' className='add-only' value='Ideation' /> Ideation
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSuicidality_3' name='cbSuicidality_3' className='add-only' value='Plan' /> Plan
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSuicidality_4' name='cbSuicidality_4' className='add-only' value='IntentWoMeans' /> Intent w/o Means
                        </td>
                    </tr>
                    <tr>                        
                        <td className='w-187'>
                            <input type='checkbox' id='cbSuicidality_5' name='cbSuicidality_5' className='add-only' value='IntentWMeans' /> Intent w/ Means
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Homicidality</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHomicidality_1' name='cbHomicidality_1' className='add-only' value='None' /> None
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHomicidality_2' name='cbHomicidality_2' className='add-only' value='Ideation' /> Ideation
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHomicidality_3' name='cbHomicidality_3' className='add-only' value='Plan' /> Plan
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHomicidality_4' name='cbHomicidality_4' className='add-only' value='IntentWoMeans' /> Intent w/o Means
                        </td>
                    </tr>
                    <tr>                        
                        <td className='w-187'>
                            <input type='checkbox' id='cbHomicidality_5' name='cbHomicidality_5' className='add-only' value='IntentWMeans' /> Intent w/ Means
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>If risk exists, consumer is able to contract not to harm:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIfRiskExistsConsumersAbleContractNotToHarm_1' name='cbIfRiskExistsConsumersAbleContractNotToHarm_1' className='add-only' value='Self' /> Self
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIfRiskExistsConsumersAbleContractNotToHarm_2' name='cbIfRiskExistsConsumersAbleContractNotToHarm_2' className='add-only' value='Others' /> Others
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Impulse Control</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbImpulseControl_1' name='cbImpulseControl_1' className='add-only' value='Sufficient' /> Sufficient
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbImpulseControl_2' name='cbImpulseControl_2' className='add-only' value='Moderate' /> Moderate
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbImpulseControl_3' name='cbImpulseControl_3' className='add-only' value='Minimal' /> Minimal
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbImpulseControl_4' name='cbImpulseControl_4' className='add-only' value='Inconsistent' /> Inconsistent
                        </td>
                    </tr>
                    <tr>                       
                        <td className='w-187'>
                            <input type='checkbox' id='cbImpulseControl_5' name='cbImpulseControl_5' className='add-only' value='Explosive' /> Explosive
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Substance Abuse</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSubstanceAbuse_1' name='cbSubstanceAbuse_1' className='add-only' value='None' /> None
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSubstanceAbuse_2' name='cbSubstanceAbuse_2' className='add-only' value='Abuse' /> Abuse
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSubstanceAbuse_3' name='cbSubstanceAbuse_3' className='add-only' value='Dependence' /> Dependence
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSubstanceAbuse_4' name='cbSubstanceAbuse_4' className='add-only' value='UnstableRemission' /> Unstable Remission
                        </td>
                    </tr>
                    <tr>                        
                        <td className='w-187'>
                            <input type='checkbox' id='cbSubstanceAbuse_5' name='cbSubstanceAbuse_5' className='add-only' value='Remission' /> Remission
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Medical Risks</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbMedicalRisk_None' name='rbMedicalRisk' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbMedicalRisk_YesExplain' name='rbMedicalRisk' className='add-only' value='YesExplain' /> Yes,Explain:&nbsp;<input type='text' id='txtMedicalRiskExplain' name='txtMedicalRiskExplain' className='add-only w-550 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Neglect</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbNeglect_1' name='cbNeglect_1' className='add-only' value='None' /> None
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbNeglect_2' name='cbNeglect_2' className='add-only' value='Emotional' /> Emotional
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbNeglect_3' name='cbNeglect_3' className='add-only' value='Nutritional' /> Nutritional
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbNeglect_4' name='cbNeglect_4' className='add-only' value='Educational' /> Educational
                        </td>
                    </tr>
                    <tr>                        
                        <td className='w-187'>
                            <input type='checkbox' id='cbNeglect_5' name='cbNeglect_5' className='add-only' value='Medical' /> Medical
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Abuse</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAbuse_1' name='cbAbuse_1' className='add-only' value='VerbalEmotional' /> Verbal/Emotional
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAbuse_2' name='cbAbuse_2' className='add-only' value='Physical' /> Physical
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAbuse_3' name='cbAbuse_3' className='add-only' value='Sexual' /> Sexual
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAbuse_4' name='cbAbuse_4' className='add-only' value='FamilyViolence' /> Family Violence
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Trauma</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTrauma_1' name='cbTrauma_1' className='add-only' value='Deaths' /> Deaths
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTrauma_2' name='cbTrauma_2' className='add-only' value='Separationfromfamily' /> Separation from family
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTrauma_3' name='cbTrauma_3' className='add-only' value='Abuse' /> Abuse
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            Violence:&nbsp;<input type='checkbox' id='cbSTrauma_5' name='cbSTrauma_5' className='add-only' value='Witnessed' /> Witnessed&nbsp;
                            &nbsp;<input type='checkbox' id='cbSTrauma_6' name='cbSTrauma_6' className='add-only' value='Experiences' /> Experiences
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Risky Behaviors</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbRiskyBehaviors_1' name='cbRiskyBehaviors_1' className='add-only' value='UnprotectedSex' /> Unprotected Sex
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbRiskyBehaviors_2' name='cbRiskyBehaviors_2' className='add-only' value='Shoplifting' /> Shoplifting
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbRiskyBehaviors_3' name='cbRiskyBehaviors_3' className='add-only' value='RecklessDriving' /> Reckless Driving
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbRiskyBehaviors_4' name='cbRiskyBehaviors_4' className='add-only' value='GangInvolvement' /> Gang Involvement
                        </td>
                    </tr>
                    <tr>                        
                        <td className='w-187'>
                            <input type='checkbox' id='cbRiskyBehaviors_5' name='cbRiskyBehaviors_5' className='add-only' value='Drugdealing' /> Drug dealing
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbRiskyBehaviors_6' name='cbRiskyBehaviors_6' className='add-only' value='CarryingUsingWeapon' /> Carrying/Using Weapon
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbRiskyBehaviors_7' name='cbRiskyBehaviors_7' className='add-only' value='Prostitution' /> Prostitution
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbRiskyBehaviors_8' name='cbRiskyBehaviors_8' className='add-only' value='EatingDisorder' /> Eating Disorder
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>If any of the above is checked, please provide details below.</span>
                    <span className='small'>Include dates, names of perpetrators if abuse/risk was reported, DFCS/CPS involvement, interventions, and outcome</span>
                    <textarea id='txtIfAnyAboveCheckedPleaseProvideDetailsBelow' name='txtIfAnyAboveCheckedPleaseProvideDetailsBelow' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <h3>D. FAMILY ASSESSMENT</h3>
                </p>
                <p className='w-750'>
                    HOUSEHOLD COMPOSITION AT TIME OF ASSESSMENT
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Name</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Relationship</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Date of Birth:</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>Age</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtName' name='txtName' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtRelationship_1' name='txtRelationship_1' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDateOfBirth_1' name='txtDateOfBirth_1' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtAge_1' name='txtAge_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtName_2' name='txtName_2' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtRelationship_2' name='txtRelationship_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDateOfBirth_2' name='txtDateOfBirth_2' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtAge_2' name='txtAge_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtName_3' name='txtName_3' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtRelationship_3' name='txtRelationship_3' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDateOfBirth_3' name='txtDateOfBirth_3' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtAge_3' name='txtAge_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtName_4' name='txtName_4' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtRelationship_4' name='txtRelationship_4' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDateOfBirth_4' name='txtDateOfBirth_4' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtAge_4' name='txtAge_4' className='add-only' /> </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>LIVING SITUATION</span>
                            <span className='small'>(Check all that apply)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbLIVINGSITUATION_1' name='cbLIVINGSITUATION_1' className='add-only' value='HomewFamilyOfOrigin' /> Home w/ Family of Origin
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbLIVINGSITUATION_2' name='cbLIVINGSITUATION_2' className='add-only' value='IndependentLiving' /> Independent Living
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbLIVINGSITUATION_3' name='cbLIVINGSITUATION_3' className='add-only' value='GroupHomeFosterHome' /> Group Home/Foster Home
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbLIVINGSITUATION_4' name='cbLIVINGSITUATION_4' className='add-only' value='Homeless' /> Homeless
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbLIVINGSITUATION_5' name='cbLIVINGSITUATION_5' className='add-only' value='AdequateHousing' /> Adequate Housing
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbLIVINGSITUATION_6' name='cbLIVINGSITUATION_6' className='add-only' value='SafetyRisksHazardous' /> Safety Risks/Hazardous
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbLIVINGSITUATION_7' name='cbLIVINGSITUATION_7' className='add-only' value='Overcrowded' /> Overcrowded
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbLIVINGSITUATION_8' name='cbLIVINGSITUATION_8' className='add-only' value='RiskofHomelessness' /> Risk of Homelessness
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>What is the family's source(s) of income? Is income monthly, bi-weekly? Is income sufficient for household expenses?</span>
                    <textarea id='txtFamilySourceIncomeMonthlyWeekly' name='txtFamilySourceIncomeMonthlyWeekly' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <h3>FAMILY HISTORY</h3>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Medical Problems</span>
                    <span className='small'> (Heart Disease, Lung Disease, Cancer, Strokes, Dementia, Diabetes, Asthma,etc.)</span>
                    <textarea id='txtMedicalProblems' name='txtMedicalProblems' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Substance Abuse</span>
                    <span className='small'>(Alcohol, Cocaine, Cannabis, Stimulants, Inhalants, Hallucinogens, Sedatives, Designer Drugs etc.) </span>
                    <textarea id='txtSubstanceAbuse' name='txtSubstanceAbuse' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Mental Illnesses/Bx Problems</span>
                    <span className='small'> (depression, schizophrenia, bipolar disorder, anxiety, ADD, ADHD, Learning Disorders, School Behavior Problems, Incarcerations, Gambling etc.) </span>
                    <textarea id='txtMentalIllnessesBxProblems' name='txtMentalIllnessesBxProblems' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Describe Consumer's relationship with biological parents.</span>
                    <textarea id='txtDescribeConsumerRelationship' name='txtDescribeConsumerRelationship' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Describe Consumer's relationship with siblings.</span>
                    <textarea id='txtDescribeConsumerRelationshipSiblings' name='txtDescribeConsumerRelationshipSiblings' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <h3>E. MEDICAL ASSESSMENT</h3>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What medical problems does the Consumer have?</span>
                    <span className='small'>(Include specific diagnosis, when problem was diagnosed, interventions)</span>
                    <textarea id='txtWhatMedicalProblemsConsumerHave' name='txtWhatMedicalProblemsConsumerHave' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What was the Consumer's health at birth? Early development?</span>
                    <span className='small'>(Include any delays with walking, crawling, sitting up, concerns with height/weight, any problems with running, jumping, climbing, balancing, coordination, problems with hearing, vision, or speech; current with immunizations)</span>
                    <textarea id='txtWhatConsumerHealthBirth' name='txtWhatConsumerHealthBirth' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What is the Consumer's prenatal history?</span>
                    <span className='small'>(Include any substance abuse, physical abuse, medications, and illnesses during mother's pregnancy, prenatal exposure to alcohol, tobacco, and other drugs)</span>
                    <textarea id='txtWhatConsumerHavePrenatal' name='txtWhatConsumerHavePrenatal' className='add-only'></textarea>
                </p>
                <p className='w-750'><h3>PRESCRIBED MEDICATIONS </h3></p>

                <p className='w-750'>
                    <span className='small'>(Include both medical and psychiatric medications)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-125'><span className='eleHeader'>Medication Name</span></td>
                        <td className='w-125'><span className='eleHeader'>Dose/Frequency</span> </td>
                        <td className='w-125'><span className='eleHeader'>Prescribed by?</span></td>
                        <td className='w-150'><span className='eleHeader'>When ?</span></td>
                        <td className='w-125'><span className='eleHeader'>Next refill?</span></td>
                        <td className='w-100'><span className='eleHeader'>Side Effects?</span></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txtMedicationNameO_1' name='txtMedicationNameO_1' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtDoseFrequency_1' name='txtDoseFrequency_1' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtPrescribedBy_1' name='txtPrescribedBy_1' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtWhenPrescribed_1' name='txtWhenPrescribed_1' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtrefill_1' name='txtrefill_1' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtSideEffects_1' name='txtSideEffects_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txtMedicationName1_2' name='txtMedicationName1_2' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtDose_Frequency1_2' name='txtDose_Frequency1_2' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtPrescribedBy1_2' name='txtPrescribedBy1_2' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtWhenPrescribed1_2' name='txtWhenPrescribed1_2' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtrefill1_2' name='txtrefill1_2' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtSideEffects1_2' name='txtSideEffects1_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txtMedicationName1_3' name='txtMedicationName1_3' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtDose_Frequency1_3' name='txtDose_Frequency1_3' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtPrescribedBy1_3' name='txtPrescribedBy1_3' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtWhenPrescribed1_3' name='txtWhenPrescribed1_3' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtrefill1_3' name='txtrefill1_3' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtSideEffects1_3' name='txtSideEffects1_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txtMedicationName1_4' name='txtMedicationName1_4' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtDose_Frequency1_4' name='txtDose_Frequency1_4' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtPrescribedBy1_4' name='txtPrescribedBy1_4' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtWhenPrescribed1_4' name='txtWhenPrescribed1_4' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtrefill1_4' name='txtrefill1_4' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtSideEffects1_4' name='txtSideEffects1_4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txtMedicationName1_5' name='txtMedicationName1_5' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtDose_Frequency1_5' name='txtDose_Frequency1_5' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtPrescribedBy1_5' name='txtPrescribedBy1_5' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtWhenPrescribed1_5' name='txtWhenPrescribed1_5' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtrefill1_5' name='txtrefill1_5' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtSideEffects1_5' name='txtSideEffects1_5' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Is Consumer compliant with medications?</span>
                    <input type='radio' id='rbSuicidalIdeation1_Yes' name='rbSuicidalIdeation1' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbSuicidalIdeation1_No' name='rbSuicidalIdeation1' className='add-only' value='No' /> No, explain:
                    <input type='text' id='txtcompliantmedications1' name='txtcompliantmedications1' className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Efficacy of Medication:</span>
                    <textarea id='txtEfficacyOfMedication' name='txtEfficacyOfMedication' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Complimentary Health Approaches</span>
                    <span className='small'>(e.g., Acupuncture, meditation, Massage etc.)</span>
                    <textarea id='txtComplimentaryHealthApproaches' name='txtComplimentaryHealthApproaches' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Is Consumer pregnant?</span>
                    <input type='radio' id='rbConsumerPregnant_Na' name='rbConsumerPregnant' className='add-only' value='Na' /> N/A &nbsp;
                    <input type='radio' id='rbConsumerPregnant_No' name='rbConsumerPregnant' className='add-only' value='No' /> No&nbsp;
                    <input type='radio' id='rbConsumerPregnant_Yes' name='rbConsumerPregnant' className='add-only' value='Yes' /> Yes, how far along is she:
                    <input type='text' id='txtHowFarAlongIsShe' name='txtHowFarAlongIsShe' className='add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-500'><span className='eleHeader'>Current Pediatrician/Primary Care Physician:</span></td>
                        <td className='w-250'><span className='eleHeader'>Phone#:</span></td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='text' id='txtCurrentPediatrician' name='txtCurrentPediatrician' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtPediatricianTelephone' name='txtPediatricianTelephone' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'><span className='eleHeader'>Current Psychiatrist:</span></td>
                        <td className='w-250'><span className='eleHeader'>Phone#:</span></td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='text' id='txtCurrentPsychiatrist' name='txtCurrentPsychiatrist' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtPsychiatristTelephone' name='txtPsychiatristTelephone' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>
                        NUTRITIONAL SCREENING/STATUS
                    </h3>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Appetite</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbAppetite_Good' name='rbAppetite' className='add-only' value='Good' /> Good
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbAppetite_Fair' name='rbAppetite' className='add-only' value='Fair' /> Fair
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbAppetite_Poor' name='rbAppetite' className='add-only' value='Poor' /> Poor,explain below
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <input type='text' id='txtExplainBelow' name='txtExplainBelow' className='add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Eating Behavior</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEating_1' name='cbEating_1' className='add-only' value='BingesOvereatsToExcess' /> Binges/overeats to excess
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEating_2' name='cbEating_2' className='add-only' value='HidingHoardingFood' />  Hiding/Hoarding food
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEating_3' name='cbEating_3' className='add-only' value='SpecialDietaryNeeds' />  Special dietary needs
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' id='cbEating_4' name='cbEating_4' className='add-only' value='RestrictFoodVomits' /> Restricts food/vomits/over-exercises to avoid weight gain
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEating_5' name='cbEating_5' className='add-only' value='None' />None
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbEating_6' name='cbEating_6' className='add-only' value='AllergiesExplainBelow' />Allergies, explain below
                            <input type='text' id='txtExplainAllergies' name='txtExplainAllergies' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Other</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbOther_Gain1' name='cbOther_Gain1' className='add-only' value='Gained1' />  Recently gained/lost significant weight
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbOther_Diet' name='cbOther_Diet' className='add-only' value='CurrentWeight' />  Current Weight:
                            <input type='text' id='txtCurrentWeight' name='txtCurrentWeight' className='add-only w-150 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOther_Gain2' name='cbOther_Gain2' className='add-only' value='CurrentHeight' /> Current Height:
                            <input type='text' id='txtCurrentHeight' name='txtCurrentHeight' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>ASSISTIVE OR ADAPTIVE DEVICES</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDevices_None' name='cbDevices_None' className='add-only' value='None1' /> None
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDevices_Glasses' name='cbDevices_Glasses' className='add-only' value='Glasses1' /> Glasses
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDevices_Walker' name='cbDevices_Walker' className='add-only' value='Walker1' /> Walker
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDevices_Braille' name='cbDevices_Braille' className='add-only' value='Braille1' /> Braille
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDevices_Hearing' name='cbDevices_Hearing' className='add-only' value='Hearing1' /> Hearing Aids
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDevices_Cane' name='cbDevices_Cane' className='add-only' value='Cane1' /> Cane
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDevices_Crutches' name='cbDevices_Crutches' className='add-only' value='Crutches1' /> Crutches
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDevices_Wheelchair' name='cbDevices_Wheelchair' className='add-only' value='Wheelchair1' /> Wheelchair
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDevices_Translated' name='cbDevices_Translated' className='add-only' value='Translated1' /> Translated Written Information
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbDevices_Translator' name='cbDevices_Translator' className='add-only' value='Translator1' /> Translator for Speaking
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbDevices_Other' name='cbDevices_Other' className='add-only' value='Other1' /> Other:
                            <input type='text' id='txtOther' name='txtOther' className='add-only w-375 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Language Delay:</span>
                    <input type='radio' id='rbLanguageDelay_No' name='rbLanguageDelay' className='add-only' value='No' /> No&nbsp;
                    <input type='radio' id='rbLanguageDelay_Yes' name='rbLanguageDelay' className='add-only' value='Yes' /> Yes, Specify:
                    &nbsp;<input type='text' id='txtLanguageDelaySpecify' name='txtLanguageDelaySpecify' className='add-only w-400 custom-add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Hearing Disorder:</span>
                    <input type='radio' id='rbHearingDisorder_No' name='rbHearingDisorder' className='add-only' value='No' /> No&nbsp;
                    <input type='radio' id='rbHearingDisorder_Yes' name='rbHearingDisorder' className='add-only' value='Yes' /> Yes, Specify:
                    &nbsp;<input type='text' id='txtHearingDisorderSpecify' name='txtHearingDisorderSpecify' className='add-only w-400 custom-add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Speech Delay:</span>
                    <input type='radio' id='rbSpeechDelay_No' name='rbSpeechDelay' className='add-only' value='No' /> No&nbsp;
                    <input type='radio' id='rbSpeechDelay_Yes' name='rbSpeechDelay' className='add-only' value='Yes' /> Yes, Specify:
                    &nbsp;<input type='text' id='txtSpeechDelaySpecify' name='txtSpeechDelaySpecify' className='add-only w-400 custom-add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Learning Disability:</span>
                    <input type='radio' id='rbLearningDisability_No' name='rbLearningDisability' className='add-only' value='No' /> No&nbsp;
                    <input type='radio' id='rbLearningDisability_Yes' name='rbLearningDisability' className='add-only' value='Yes' /> Yes, Specify:
                    &nbsp;<input type='text' id='txtLearningDisabilitySpecify' name='txtLearningDisabilitySpecify' className='add-only w-400 custom-add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Describe any significant developmental history:</span>
                    <textarea id='txtDescribeSignificantDevelopmentHistory' name='txtDescribeSignificantDevelopmentHistory' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <span className='small'> (Describe status of any current physical conditions. Describe any significant history):</span>
                    <textarea id='txtCommentsDescribe' name='txtCommentsDescribe' className='add-only'></textarea>
                </p>
                <p className='w-750'><h3>F. BEHAVIOR AND MENTAL HEALTH ASSESSMENT</h3></p>
                <p className='w-750'>
                    Please complete the below checklist for symptoms:
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Key:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><b>Severity Rating:</b></td>
                        <td className='w-375'><b>Duration Rating:</b></td>
                    </tr>
                    <tr>
                        <td className='w-50'><b>1=</b></td>
                        <td className='w-325'>Mild </td>
                        <td className='w-50'><b>1=</b></td>
                        <td className='w-325'>Less than 1 Month</td>
                    </tr>
                    <tr>
                        <td className='w-50'><b>2=</b></td>
                        <td className='w-325'>Moderate </td>
                        <td className='w-50'><b>2=</b></td>
                        <td className='w-325'>1 to 6 Months</td>
                    </tr>
                    <tr>
                        <td className='w-50'><b>3=</b></td>
                        <td className='w-325'>Severe </td>
                        <td className='w-50'><b>3=</b></td>
                        <td className='w-325'>7 to 11 Months</td>
                    </tr>
                    <tr>
                        <td className='w-50'></td>
                        <td className='w-325'></td>
                        <td className='w-50'><b>4=</b></td>
                        <td className='w-325'>More than 1 Year</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-450'><span className='eleHeader'>Symptom/Problem</span></td>
                        <td className='w-150'><span className='eleHeader'>Severity</span></td>
                        <td className='w-150'><span className='eleHeader'>Duration</span></td>
                    </tr>
                    <tr>
                        <td className='w-450'>1.	Anxiety</td>
                        <td className='w-150'>
                            <input type='text' id='txtSeverity_1' name='txtSeverity_1' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDuration_1' name='txtDuration_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>2.	Appetite Problems</td>
                        <td className='w-150'>
                            <input type='text' id='txtSeverity_2' name='txtSeverity_2' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDuration_2' name='txtDuration_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>3.	Bizarre Behavior</td>
                        <td className='w-150'>
                            <input type='text' id='txtSeverity_3' name='txtSeverity_3' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDuration_3' name='txtDuration_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>4.	Bizarre Ideations (Delusions)</td>
                        <td className='w-150'>
                            <input type='text' id='txtSeverity_4' name='txtSeverity_4' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDuration_4' name='txtDuration_4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>5.	Conduct Problems</td>
                        <td className='w-150'>
                            <input type='text' id='txtSeverity_5' name='txtSeverity_5' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDuration_5' name='txtDuration_5' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>6.	Depression</td>
                        <td className='w-150'>
                            <input type='text' id='txtSeverity_6' name='txtSeverity_6' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDuration_6' name='txtDuration_6' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>7.	Eating Disorder</td>
                        <td className='w-150'>
                            <input type='text' id='txtSeverity_7' name='txtSeverity_7' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDuration_7' name='txtDuration_7' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>8.	Family Problems</td>
                        <td className='w-150'>
                            <input type='text' id='txtSeverity_8' name='txtSeverity_8' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDuration_8' name='txtDuration_8' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>9.	Gender Issues</td>
                        <td className='w-150'>
                            <input type='text' id='txtSeverity_9' name='txtSeverity_9' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDuration_9' name='txtDuration_9' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>10.	Impaired Memory</td>
                        <td className='w-150'>
                            <input type='text' id='txtSeverity_10' name='txtSeverity_10' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDuration_10' name='txtDuration_10' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>11.	Indep. Living Problems</td>
                        <td className='w-150'>
                            <input type='text' id='txtSeverity_11' name='txtSeverity_11' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDuration_11' name='txtDuration_11' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>12.	Lack of Support System</td>
                        <td className='w-150'>
                            <input type='text' id='txtSeverity_12' name='txtSeverity_12' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDuration_12' name='txtDuration_12' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>13.	Loss of Energy</td>
                        <td className='w-150'>
                            <input type='text' id='txtSeverity_13' name='txtSeverity_13' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDuration_13' name='txtDuration_13' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>14.	Loss of Interest</td>
                        <td className='w-150'>
                            <input type='text' id='txtSeverity_14' name='txtSeverity_14' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDuration_14' name='txtDuration_14' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>15.	Obsessive/Compulsive</td>
                        <td className='w-150'>
                            <input type='text' id='txtSeverity_15' name='txtSeverity_15' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDuration_15' name='txtDuration_15' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>16.	Panic Attacks</td>
                        <td className='w-150'>
                            <input type='text' id='txtSeverity_16' name='txtSeverity_16' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDuration_16' name='txtDuration_16' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>17.	Paranoid Ideation</td>
                        <td className='w-150'>
                            <input type='text' id='txtSeverity_17' name='txtSeverity_17' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDuration_17' name='txtDuration_17' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>18.	Phobia</td>
                        <td className='w-150'>
                            <input type='text' id='txtSeverity_18' name='txtSeverity_18' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDuration_18' name='txtDuration_18' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>19.	Poor Interpersonal Skills</td>
                        <td className='w-150'>
                            <input type='text' id='txtSeverity_19' name='txtSeverity_19' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDuration_19' name='txtDuration_19' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>20.	Poor Judgment</td>
                        <td className='w-150'>
                            <input type='text' id='txtSeverity_20' name='txtSeverity_20' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDuration_20' name='txtDuration_20' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>21. Poor Self Care Skills</td>
                        <td className='w-150'>
                            <input type='text' id='txtSeverity_21' name='txtSeverity_21' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDuration_21' name='txtDuration_21' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>22. School Problems</td>
                        <td className='w-150'>
                            <input type='text' id='txtSeverity_22' name='txtSeverity_22' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDuration_22' name='txtDuration_22' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>23. Sexual Acting Out</td>
                        <td className='w-150'>
                            <input type='text' id='txtSeverity_23' name='txtSeverity_23' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDuration_23' name='txtDuration_23' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>24. Sleep Problems</td>
                        <td className='w-150'>
                            <input type='text' id='txtSeverity_24' name='txtSeverity_24' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDuration_24' name='txtDuration_24' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>25. Somatization</td>
                        <td className='w-150'>
                            <input type='text' id='txtSeverity_25' name='txtSeverity_25' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDuration_25' name='txtDuration_25' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>26. Unusual Body Movements</td>
                        <td className='w-150'>
                            <input type='text' id='txtSeverity_26' name='txtSeverity_26' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDuration_26' name='txtDuration_26' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>27. Other</td>
                        <td className='w-150'>
                            <input type='text' id='txtSeverity_27' name='txtSeverity_27' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDuration_27' name='txtDuration_27' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>28. Other</td>
                        <td className='w-150'>
                            <input type='text' id='txtSeverity_28' name='txtSeverity_28' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDuration_28' name='txtDuration_28' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>If any of the above were checked, please provide specific details below. Please indicate frequency and intensity of symptoms.</span>
                    <textarea id='txtAssistiv' name='txtAssistiv' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Has Individual ever been diagnosed with a mental health problem?</span>
                    <span className='small'>(Include specific diagnosis, when problem was diagnosed, interventions)</span>
                    <textarea id='txtMedCondition5' name='txtMedCondition5' className='add-only'></textarea>
                </p>
                <p className='w-750'> <h4>
                    SUBSTANCE ABUSE INFORMATION
                </h4></p>
                <table>
                    <tr>
                        <td className='w-200'><span className='eleHeader'>Substance Name</span></td>
                        <td className='w-100'><span className='eleHeader'>Age of 1st Use</span></td>
                        <td className='w-100'><span className='eleHeader'>Age of Heaviest Use</span></td>
                        <td className='w-200'><span className='eleHeader'>Frequency/Amount</span></td>
                        <td className='w-150'><span className='eleHeader'>Date of Last use</span></td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            Alcohol
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtAgeIst1' name='txtAgeIst1' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtAgHeaviest1' name='txtAgHeaviest1' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtFrequency1' name='txtFrequency1' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtDateLast1' name='txtDateLast1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            Cannabis
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtAgeIst2' name='txtAgeIst2' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtAgHeaviest2' name='txtAgHeaviest2' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtFrequency2' name='txtFrequency2' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtDateLast2' name='txtDateLast2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            Cocaine
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtAgeIst3' name='txtAgeIst3' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtAgHeaviest3' name='txtAgHeaviest3' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtFrequency3' name='txtFrequency3' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtDateLast3' name='txtDateLast3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            Stimulants<span className='small'>
                                (Crystal, speed, amphetamines)  </span>
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtAgeIst4' name='txtAgeIst4' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtAgHeaviest4' name='txtAgHeaviest4' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtFrequency4' name='txtFrequency4' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtDateLast4' name='txtDateLast4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            Methamphetamine
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtAgeIst5' name='txtAgeIst5' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtAgHeaviest5' name='txtAgHeaviest5' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtFrequency5' name='txtFrequency5' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtDateLast5' name='txtDateLast5' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            Inhalants<span className='small'>
                                (LSD, PCP, mushrooms) </span>
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtAgeIst6' name='txtAgeIst6' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtAgHeaviest6' name='txtAgHeaviest6' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtFrequency6' name='txtFrequency6' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtDateLast6' name='txtDateLast6' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            Opioids
                            <span className='small'> (Heroine, Narcotics, Methadone)  </span>
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtAgeIst7' name='txtAgeIst7' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtAgHeaviest7' name='txtAgHeaviest7' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtFrequency7' name='txtFrequency7' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtDateLast7' name='txtDateLast7' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            Sedative/Hypnotics
                            <span className='small'>(Valium, Xanax) </span>
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtAgeIst8' name='txtAgeIst8' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtAgHeaviest8' name='txtAgHeaviest8' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtFrequency8' name='txtFrequency8' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtDateLast8' name='txtDateLast8' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            Designer Drugs
                            <span className='small'> (Herbal, Steroids, Cough Syrup)  </span>
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtAgeIst9' name='txtAgeIst9' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtAgHeaviest9' name='txtAgHeaviest9' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtFrequency9' name='txtFrequency9' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtDateLast9' name='txtDateLast9' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            Tobacco
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtAgeIst10' name='txtAgeIst10' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtAgHeaviest10' name='txtAgHeaviest10' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtFrequency10' name='txtFrequency10' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtDateLast10' name='txtDateLast10' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>What consequences has the Consumer faced as a result of the Drug/Alcohol use?</span>
                    <span className='small'>(Include hangovers, DT's, Blackouts, Binges, Overdoses, Seizures, GI Bleeding, Job Loss, DUI's, Assaults, Incarcerations, Homicides, etc.)</span>
                    <textarea id='txtConsequences' name='txtConsequences' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-500'>
                            <span className='eleHeader'>Longest period of sobriety?</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>When?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='text' id='txtLongest' name='txtLongest' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='date' id='txtWhen' name='txtWhen' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Consumer's Legal History</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbLegalHistory_8' name='cbLegalHistory_8' className='add-only' value='None' /> None
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbProbation7' name='cbProbation7' className='add-only' value='Probation' /> Restraining Order
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbProbation6' name='cbProbation6' className='add-only' value='Parole' /> Parole
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbProbation6' name='cbProbation6' className='add-only' value='Probation' /> DFCS/CPS and County
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbProbation6' name='cbProbation6' className='add-only' value='Dui' /> DUI
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbProbation6' name='cbProbation6' className='add-only' value='Probation' /> Probation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbProbation6' name='cbProbation6' className='add-only' value='NotOnProbationParole' /> Not on probation/Parole
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            Name of Prob/Parole Officer, Case Manager:
                            <input type='text' id='txtFrequencyO9' name='txtFrequencyO9' className='add-only w-400 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Did consumer receive treatment in the past</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbDidConsumerRecievedTreatment_No' name='rbDidConsumerRecievedTreatment' className='add-only' value='No' /> No
                        </td>
                        <td className='w-500'>
                            <input type='radio' id='rbDidConsumerRecievedTreatment_Yes' name='rbDidConsumerRecievedTreatment' className='add-only' value='Yes' /> Yes, specify treatment/interventions received:
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtDidConsumerTratmentExxplain' name='txtDidConsumerTratmentExxplain' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Was the consumer placed in a recovery environment?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbWasTheConsumerPlacedInRecoveryEnvironment_No' name='rbWasTheConsumerPlacedInRecoveryEnvironment' className='add-only' value='No' /> No
                        </td>
                        <td className='w-500'>
                            <input type='radio' id='rbWasTheConsumerPlacedInRecoveryEnvironment_Yes' name='rbWasTheConsumerPlacedInRecoveryEnvironment' className='add-only' value='Yes' /> Yes, specify length of stay:
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtWasTheConsumerPlacedInRecoveryEnvironment' name='txtWasTheConsumerPlacedInRecoveryEnvironment' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Was consumer compliant during past treatment</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbWasConsumerComplaintDuringTreatmentPast_Yes' name='rbWasConsumerComplaintDuringTreatmentPast' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-500'>
                            <input type='radio' id='rbWasConsumerComplaintDuringTreatmentPast_No' name='rbWasConsumerComplaintDuringTreatmentPast' className='add-only' value='No' /> No, explain:
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtWasConsumerComplaintDuringTreatmentPast' name='txtWasConsumerComplaintDuringTreatmentPast' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Is consumer currently in a treatment environment</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbIsConsumerCurrentlyInTreatmentEnvironment_No' name='rbIsConsumerCurrentlyInTreatmentEnvironment' className='add-only' value='No' /> No
                        </td>
                        <td className='w-500'>
                            <input type='radio' id='rbIsConsumerCurrentlyInTreatmentEnvironment_Yes' name='rbIsConsumerCurrentlyInTreatmentEnvironment' className='add-only' value='Yes' /> Yes, specify length of stay:
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtIsConsumerCurrentlyInTreatmentEnvironment' name='txtIsConsumerCurrentlyInTreatmentEnvironment' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Is consumer currently in a recovery environment?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbIsConsumerCurrentlyInRecoveryEnvironment_No' name='rbIsConsumerCurrentlyInRecoveryEnvironment' className='add-only' value='No' /> No
                        </td>
                        <td className='w-500'>
                            <input type='radio' id='rbIsConsumerCurrentlyInRecoveryEnvironment_Yes' name='rbIsConsumerCurrentlyInRecoveryEnvironment' className='add-only' value='Yes' /> Yes, specify:
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtIsConsumerCurrentlyInRecoveryEnvironment' name='txtIsConsumerCurrentlyInRecoveryEnvironment' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Is consumer able and willing to engage in treatment if not receiving any</span>
                    <span className='small'>(What is the consumer saying)?</span>
                    <textarea id='txtConsumerAbleWillingTreatment' name='txtConsumerAbleWillingTreatment' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <h3>
                        G. EDUCATION ASSESSMENT
                    </h3>
                </p>
                <table>
                    <tr>
                        <td className='w-600'>
                            <span className='eleHeader'>School Currently Attending:</span>
                            <input type='text' id='txtSchool' name='txtSchool' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Grade:</span>
                            <input type='text' id='txtCurrentGrade' name='txtCurrentGrade' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Literacy Level:</span>
                            <input type='text' id='txtLiteracyLevel' name='txtLiteracyLevel' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Intellectual Level:</span>
                            <input type='text' id='txtIntellectualLevel' name='txtIntellectualLevel' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Is the Consumer in special classes? If so, what type?</span>
                    <textarea id='txtIsTheConsumerInSpecialClassesIfSoWhatType' name='txtIsTheConsumerInSpecialClassesIfSoWhatType' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Has the Consumer ever been suspended or expelled from school and/or bus?</span>
                    <span className='small'>(This should include family, friend, teacher supports, hobbies, community resources, education)</span>
                    <textarea id='txtHasTheConsumerEverBeenSuspendedExpelledFromSchoolBus' name='txtHasTheConsumerEverBeenSuspendedExpelledFromSchoolBus' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does the Consumer have frequent absences, truancy?</span>
                    <textarea id='txtDoesTheConsumerHaveFrequentAbsencesTruancy' name='txtDoesTheConsumerHaveFrequentAbsencesTruancy' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does the Consumer need or is receiving tutoring services?</span>
                    <textarea id='txtDoesTheConsumerNeedReceivingTutoringServices' name='txtDoesTheConsumerNeedReceivingTutoringServices' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Is the Consumer currently failing, and has the Consumer ever been retained?</span>
                    <textarea id='txtIsTheConsumerCurrentlyFailingAndHasTheConsumerEverBeenRetained' name='txtIsTheConsumerCurrentlyFailingAndHasTheConsumerEverBeenRetained' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What does the Consumer like and dislike about school? </span>
                    <textarea id='txtWhatDoesTheConsumerLikeAndDislikeAboutSchool' name='txtWhatDoesTheConsumerLikeAndDislikeAboutSchool' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Describe Consumer's peer relationships?</span>
                    <span className='small'> (Include both the Consumer's and parent's descriptions)</span>
                    <textarea id='txtDescribeConsumerPeerRelationships' name='txtDescribeConsumerPeerRelationships' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <h3>
                        H. SNAP: STRENGHTS, NEEDS, ABILITIES, PREFERENCES
                    </h3>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What strengths does the Consumer have that affects their quality of life?</span>
                    <span className='small'>(This should include family, friend, teacher supports, hobbies, community resources, education)</span>
                    <textarea id='txtStrenghtDoesConsumerAffects' name='txtStrenghtDoesConsumerAffects' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What is needed to increase the Consumer's quality of life?</span>
                    <span className='small'> (Name specific interventions, resources for biological, psychological, and social/environmental barriers)</span>
                    <textarea id='txtWhatIsNeededIncreaseConsumersQualityLife' name='txtWhatIsNeededIncreaseConsumersQualityLife' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What are the Consumer's abilities and skills that would help increase his/her quality of life?</span>
                    <span className='small'> (This should include personality traits, work skills,academic skills)</span>
                    <textarea id='txtNeededIncreaseConsumerQualityLife' name='txtNeededIncreaseConsumerQualityLife' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Consumer Preference?</span>
                    <textarea id='txtConsumerPreference' name='txtConsumerPreference' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What strengths does the parent believe the Consumer has?</span>
                    <textarea id='txtWhatStrengthsDoesTheParentBelieveTheConsumerHas' name='txtWhatStrengthsDoesTheParentBelieveTheConsumerHas' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What are the family's strengths?</span>
                    <textarea id='txtWhatAreTheFamilyStrengths' name='txtWhatAreTheFamilyStrengths' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> I. PROGRAM QUALIFIERS  </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbIProgramQualifiers1' name='cbIProgramQualifiers1' className='add-only' value='IProgramQualifiers1' /> Consumer is affected by an emotional disturbance or substance related disorder.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbIProgramQualifiers2' name='cbIProgramQualifiers2' className='add-only' value='IProgramQualifiers2' /> Consumer has shown early indications of behaviors that could be disruptive to the community and the family/support system if behavior intensified.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbIProgramQualifiers3' name='cbIProgramQualifiers3' className='add-only' value='IProgramQualifiers3' /> Consumer has shown early indications behaviors/ functional problems that could cause risk of removal from the home if problems intensified
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbIProgramQualifiers4' name='cbIProgramQualifiers4' className='add-only' value='IProgramQualifiers4' />  Consumer has shown early indications of poor school performance (poor grades, disruptive behavior, lack of motivation, suspension).
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbIProgramQualifiers5' name='cbIProgramQualifiers5' className='add-only' value='IProgramQualifiers5' />  Consumer has shown early indications of delinquent behaviors that could result in legal system involvement
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbIProgramQualifiers6' name='cbIProgramQualifiers6' className='add-only' value='IProgramQualifiers6' /> Consumer has shown early indications of behavioral/functional problems that could result in multiple agency involvement if problems intensified.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbIProgramQualifiers7' name='cbIProgramQualifiers7' className='add-only' value='IProgramQualifiers7' /> Consumer demonstrates behaviors that are a risk of harm to self, others, or property.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbIProgramQualifiers8' name='cbIProgramQualifiers8' className='add-only' value='IProgramQualifiers8' />  Consumer indicates the need for detoxification services.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbIProgramQualifiers9' name='cbIProgramQualifiers9' className='add-only' value='IProgramQualifiers9' /> Treatment at a Lower Level of Care has been attempted or given serious consideration (Has this consumer been in outpatient care or has outpatient care been considered? If considered, why not tried?).
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbIProgramQualifiers10' name='cbIProgramQualifiers10' className='add-only' value='IProgramQualifiers10' /> Consumer and/or family have insufficient or severely limited resources or skills to cope with an immediate crisis.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbIProgramQualifiers11' name='cbIProgramQualifiers11' className='add-only' value='IProgramQualifiers11' /> Consumer and/or family issues are unmanageable in traditional outpatient treatment and require intensive, coordinated clinical and supportive intervention.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbIProgramQualifiers12' name='cbIProgramQualifiers12' className='add-only' value='IProgramQualifiers12' />  Consumer is at immediate risk for out-of-home placement or is currently in out-of-home placement and reunification imminent.
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>If any of the above were checked, please provide details below</span>
                    <textarea id='txtIfAnyOfTheAboveWereCheckedPleaseProvideDetailsBelow' name='txtIfAnyOfTheAboveWereCheckedPleaseProvideDetailsBelow' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <h3>
                        J. DIAGNOSTIC IMPRESSION
                    </h3> <br />
                    <b>ICD-10/DSM-V</b>
                </p>
                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Primary Diagnosis:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtPrimaryDiagnosis' name='txtPrimaryDiagnosis' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Secondary Diagnosis:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtSecondaryDiagnosis' name='txtSecondaryDiagnosis' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Tertiary Diagnosis:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtTertiaryDiagnosis' name='txtTertiaryDiagnosis' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Provisional Diagnosis:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtProvisionalDiagnosis' name='txtProvisionalDiagnosis' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Provisional II Diagnosis:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtProvisionalIIDiagnosis' name='txtProvisionalIIDiagnosis' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>K. INTERPRETIVE SUMMARY</span>
                    <span className='small'>(Please write a statement that integrates all assessments: describes central themes; reason (s) the individual is seeking services; individual's acceptance or understanding of his/her problems/needs and strategies for relapse prevention; individual's apparent strengths and functional limitations; description of potential barriers to community inclusion/integration and successful attainment of goals and movement towards recovery; complicating conditions/disorders, including a discussion of substance abuse patterns and serious medical conditions; explanation of choice goals to be worked on; description of risk versus choice issues. The summary should begin with a brief description of the individual) </span>
                    <textarea id='txtInterpretiveSummary' name='txtInterpretiveSummary' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Assessor Name: </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Assessor Signature & Credential : </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Supervisor Signature & Credential : </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>

        


            </div>
        </form>

    )
}